import Investment, {InvestmentType} from './interfaces/investment';
import DateFormatHelper from '@/components/Helper/DateFormatHelper';
import SubInvestorHelper from '@/components/Helper/SubInvestorHelper';

class LoanInvestment implements Investment {
    private _investSum: number = 0;
    private _isRunning: boolean = false;
    private _interest: number = -1;
    private _investor: string = '';
    private _createdAt: string = '';
    private _title: string = '';
    private _period: string = '';
    private _financingEntity: string = '';
    private _id: number = -1;
    private _datePayBack: string = '';

    constructor(data: any, userdata: any) {
        this._investSum = Number(data.invest_sum || 0);
        this._isRunning = data.status !== 'repaid';
        this._interest = Number(data.payout_number);
        this._createdAt = data.created_at;
        this._investor = SubInvestorHelper.extractName(data, userdata);
        this._title = data.title;
        this._period = (data.datePayBack && data.dateStartDate)
            ? `${DateFormatHelper.differenceInMonth(data.dateStartDate, data.datePayBack, true)}`
            : '-';
        this._financingEntity = data.financing_entity;
        this._id = data.signing_id;
        this._datePayBack = data.datePayBack;
    }

    isRunning(): boolean {
        return this._isRunning;
    }

    getInvestSum(): number {

        return this._investSum;
    }

    getInterest(): number {
        return this._interest;
    }

    getInvestor(): string {
        return this._investor;
    }

    getCreatedAt(): string {
        return this._createdAt;
    }

    getPeriod(): string {
        return this._period;
    }

    getTitle(): string {
        return this._title;
    }

    getFinancingEntity(): string {
        return this._financingEntity;
    }

    getType(): InvestmentType {
        return InvestmentType.LOAN;
    }

    getId(): number {
        return this._id;
    }

    getDatePayBack(): string {
        return this._datePayBack;
    }

    getPaidAt(): string | null {
        return null;
    }
}

export default LoanInvestment;
